function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Children, cloneElement, useCallback, useEffect, useRef, useState } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useElementSize, useRefGetter } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
import { useCarousel } from '../../hooks/carousel';
import { CarouselSlider } from './CarouselSlider';
export var CarouselWrapper = React.forwardRef(function (props, ref) {
  var onActiveChange = props.onActiveChange,
      className = props.className,
      children = props.children,
      extra = _objectWithoutProperties(props, ["onActiveChange", "className", "children"]);

  var carousel = useCarousel();
  var containerRef = useRef(null);
  var wrapperRef = useRef(null);
  var containerCls = usePrefixCls('carousel-container');
  var wrapperCls = classnames(usePrefixCls('carousel-wrapper'), className);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  React.useImperativeHandle(ref, function () {
    return {
      goTo: function goTo(nextIndex) {
        return carousel.slideTo(nextIndex);
      },
      prev: function prev() {
        if (carousel.sliders.length <= 1) {
          carousel.slideTo(0);
        } else {
          carousel.slideTo(carousel.currentIndex - 1);
        }
      },
      next: function next() {
        return carousel.slideTo(carousel.currentIndex + 1);
      }
    };
  });

  var getPrevAndNext = function getPrevAndNext() {
    var prev = carousel.currentIndex - 1 < 0 ? carousel.sliders.length - 1 : carousel.currentIndex - 1;
    var next = carousel.currentIndex + 1 > carousel.sliders.length - 1 ? 0 : carousel.currentIndex + 1;
    return [prev, next];
  };

  var getOpacity = function getOpacity(i) {
    var _getPrevAndNext = getPrevAndNext(),
        _getPrevAndNext2 = _slicedToArray(_getPrevAndNext, 2),
        prev = _getPrevAndNext2[0],
        next = _getPrevAndNext2[1];

    if (i === prev || i === next) {
      return 0.8;
    }

    if (i === carousel.currentIndex) {
      return 1;
    }

    return 0;
  };

  var handleFadeSliderChange = function handleFadeSliderChange(init) {
    var containerDom = containerRef.current;
    var slidersDom = containerDom.children;

    for (var i = 0; i < slidersDom.length; i++) {
      Object.assign(slidersDom[i].style, {
        position: 'absolute',
        left: 0,
        right: 0,
        width: '100%',
        opacity: i === carousel.currentIndex ? 1 : 0,
        transitionDuration: init ? '0ms' : "".concat(carousel.delay, "ms")
      });
    }
  };

  var handleCoverflowChange = function handleCoverflowChange(init) {
    var containerDom = containerRef.current;
    var slidersDom = containerDom.children;

    var _getPrevAndNext3 = getPrevAndNext(),
        _getPrevAndNext4 = _slicedToArray(_getPrevAndNext3, 2),
        prevIndex = _getPrevAndNext4[0],
        nextIndex = _getPrevAndNext4[1];

    for (var i = 0; i < slidersDom.length; i++) {
      var active = carousel.currentIndex === i;
      var tranSize = carousel.carouselSize.width / 4;

      if (prevIndex === i) {
        tranSize -= carousel.carouselSize.width * 0.32;
      }

      if (nextIndex === i) {
        tranSize += carousel.carouselSize.width * 0.32;
      }

      Object.assign(slidersDom[i].style, {
        position: 'absolute',
        left: 0,
        right: 0,
        width: "".concat(carousel.carouselSize.width / 2, "px"),
        transitionDuration: init ? '0ms' : "".concat(carousel.delay, "ms"),
        transform: "scale(".concat(active ? 1 : 0.8, ") translateX(").concat(tranSize, "px)"),
        transformOrigin: 'right',
        opacity: getOpacity(i),
        zIndex: active ? 2 : 1
      });
    }
  };

  var handleTranslate = useCallback(function (style) {
    if (carousel.effect === 'slide') {
      Object.assign(containerRef.current.style, style);
    } else if (carousel.effect === 'cover-flow') {
      handleCoverflowChange();
    } else {
      handleFadeSliderChange();
    }
  }, []);
  var handleInitContainer = useCallback(function (carouselSize) {
    var sliders = carousel.sliders;
    var containerDom = containerRef.current;
    var slidersDom = containerDom.children;

    if (carousel.effect === 'slide') {
      Object.assign(containerDom.style, {
        width: "".concat(sliders.length * carouselSize.width, "px")
      });

      var _iterator = _createForOfIteratorHelper(slidersDom),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slider = _step.value;
          Object.assign(slider.style, {
            width: '100%'
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if (carousel.effect === 'cover-flow') {
      Object.assign(containerDom.style, {
        width: "".concat(carouselSize.width, "px")
      });
      handleCoverflowChange(true);
    } else {
      Object.assign(containerDom.style, {
        width: "".concat(carouselSize.width, "px")
      });
      handleFadeSliderChange(true);
    }
  }, []);
  var handleActiveIndexChange = useRefGetter(function (currentIndex) {
    onActiveChange && onActiveChange(currentIndex);
  });
  var handleFilterChild = useCallback(function () {
    var sliders = [];
    var others = [];
    Children.map(children, function (child) {
      if (child.type === CarouselSlider) {
        sliders.push(child);
      } else {
        others.push(child);
      }
    });
    return [sliders, others];
  }, [children]);

  var _handleFilterChild = handleFilterChild(),
      _handleFilterChild2 = _slicedToArray(_handleFilterChild, 2),
      originalChild = _handleFilterChild2[0],
      otherChild = _handleFilterChild2[1];

  useEffect(function () {
    var handleActiveChange = handleActiveIndexChange();
    carousel.addListener('begin-translate', handleTranslate);
    carousel.addListener('active-index-change', handleActiveChange);
    carousel.addListener('carousel-size-change', handleInitContainer);
    return function () {
      carousel.removeListener('begin-translate', handleTranslate);
      carousel.removeListener('active-index-change', handleActiveChange);
      carousel.removeListener('carousel-size-change', handleInitContainer);
    };
  }, []);
  useEffect(function () {
    carousel.initCarouselSize();
    carousel.initcurrentIndex();
  }, [children]);
  useElementSize(wrapperRef, function () {
    return true;
  }, function (wrapperSize) {
    setReady(true);
    carousel.setCarouselSize(wrapperSize);
  });
  carousel.cloneChild(originalChild);
  return React.createElement("div", Object.assign({
    ref: wrapperRef,
    className: wrapperCls
  }, extra), React.createElement("div", {
    ref: containerRef,
    className: containerCls
  }, ready && Children.map(carousel.sliders, function (child, index) {
    return cloneElement(child, {
      key: index
    });
  })), otherChild);
});